export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">关于我们</h2>
            <div className="text-sm text-foreground-600 leading-relaxed space-y-3 max-w-xl mx-auto lg:mx-0">
              <p>
                爱漫画网诞生于对漫画的无限热爱。我们是一群资深的韩漫、日漫和国漫爱好者，深知找一部好漫画有时就像大海捞针。于是我们打造了这个平台——一个专注于韩漫推荐、日漫大全和国漫排行榜的免费漫画在线阅读空间。
              </p>
              <p>
                从热门漫画排行到最新漫画连载，从经典回顾到新番速递，我们用心筛选每一部作品，确保漫画大全中的内容都值得你的时间。每天 200+ 话的更新速度、超过 30,000 部作品的收录规模，以及 500 万活跃漫迷的信任，是我们前行的最大动力。
              </p>
              <p>
                无论你是韩漫的忠实粉丝、日漫的铁杆读者，还是国漫的新晋爱好者，爱漫画网都为你敞开大门。在这里，找漫追漫更轻松，阅读漫画更纯粹。
              </p>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[400px]">
            <div className="relative aspect-square rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%2520cozy%2520illustration%2520of%2520a%2520reading%2520nook%2520with%2520manga%2520comic%2520books%2520scattered%2520on%2520a%2520wooden%2520table%2520soft%2520warm%2520lighting%2520from%2520a%2520desk%2520lamp%2520comfortable%2520armchair%2520bookshelves%2520in%2520background%2520artistic%2520editorial%2520style%2520with%2520gentle%25atmosphere&width=800&height=800&seq=about-manga&orientation=squarish"
                alt="爱漫画网 - 关于我们"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}